module.exports = __webpack_public_path__ + "img/item18.5e20bbc4.png";